import { COLORS } from '@constants';
import { Icon } from '@ui';
import styled from 'styled-components';

export const InfoIcon = styled(Icon.HintIcon)`
    &:hover {
        color: ${COLORS.$gray80Black};
        cursor: pointer;
    }
`;
